const translations = {
    appliedMixtureBasis: '"% in Applied Mixture" basis',
    appliedMixtureBasisUnavailable:
        'No total spray mix is recorded for this application, so there is no mixture to measure an active ingredient against.',
    appliedMixtureBasisWithFigures:
        'Total spray mix {{totalMixVolume}} ({{totalMixRate}}) over {{treatedArea}} acres: {{carrierVolume}} carrier and {{liquidProductVolume}} liquid product{{dryProducts}}. Liquid a.i. = label % x (product volume / {{totalMixVolume}} total mix volume), by volume. Dry a.i. = (product amount x label %) / {{totalMixMass}} total mix weight, by weight, at a spray density equal to water, {{sprayDensity}}.',
    dryProducts: ', plus {{dryProductWeight}} dry product'
};

export default translations;
